import Swiper from 'swiper';
import { refs, domReady } from '../modules/utils.js';
import { matches as mqMatches } from '../modules/media-queries.js';

class SwiperSlider extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    this.#initSlider();
    this.#listeners();
  }

  #listeners() {
    document.addEventListener('swiperslidernav:next', () => {
      this.slider?.slideNext();
    });

    document.addEventListener('swiperslidernav:prev', () => {
      this.slider?.slidePrev();
    });

    document.addEventListener('mediaquery:change', ({ detail }) => {
      if (detail.key === 'small') {
        this.#initSlider();
      }
    });
  }

  #initSlider() {
    const spaceBetween = 24;
    const isSmallViewport = mqMatches('small');

    let slidesPerView = 1;
    if (this.dataset.slidesPerView === 'auto') {
      slidesPerView = 'auto';
    }
    else {
      if (this.dataset.slidesPerView) {
        slidesPerView = parseFloat(this.dataset.slidesPerView);
      }
      if (isSmallViewport && this.dataset.slidesPerViewSm) {
        slidesPerView = parseFloat(this.dataset.slidesPerViewSm);
      }
    }

    this.slider = new Swiper(
      this,
      {
        slidesPerView,
        spaceBetween,
        loop: false
      }
    );
  }
}

customElements.define('swiper-slider', SwiperSlider);
